// Kapselt den mehrstufigen Login, damit Zugangsdaten und TOTP-Daten getrennt verarbeitet werden.
import axios from "axios";

const authUrl = (path) => `${process.env.REACT_APP_API_SERVICE_URL}/auth${path}`;

export const login = (email, password) =>
	axios.post(authUrl("/login"), { email, password });

export const verifyTotp = (challengeId, code) =>
	axios.post(authUrl("/mfa/verify"), {
		challenge_id: challengeId,
		code
	});

export const confirmTotpEnrollment = (challengeId, code) =>
	axios.post(authUrl("/mfa/enrollment/confirm"), {
		challenge_id: challengeId,
		code
	});

export const startTotpEnrollment = (accessToken) =>
	axios.post(authUrl("/mfa/enrollment"), {}, {
		headers: { Authorization: `Bearer ${accessToken}` }
	});
